// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-pro-layout .ant-pro-layout-content {
  padding: 24px;
  margin: 0;
}
.ant-pro-layout .ant-pro-layout-content-children {
  min-height: 280px;
}
.user-display-name {
  color: #8b5cf6 !important;
}
.user-display-name * {
  color: #8b5cf6 !important;
}
.ant-pro-layout .ant-pro-layout-header {
  background: linear-gradient(90deg, #001529 0%, #002140 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo {
  background: transparent !important;
}
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo img,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo img {
  height: 32px !important;
  width: 32px !important;
  border-radius: 6px;
  margin-right: 12px;
}
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo div {
  color: #ffffff !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  margin: 0 !important;
}
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:hover,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:hover,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:active,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:active,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:visited,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:visited,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:focus,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:focus {
  color: #ffffff !important;
  text-decoration: none !important;
}
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:hover h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:hover h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:active h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:active h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:visited h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:visited h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:focus h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:focus h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:hover .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:hover .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:active .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:active .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:visited .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:visited .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:focus .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:focus .ant-typography,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:hover span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:hover span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:active span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:active span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:visited span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:visited span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:focus span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:focus span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:hover div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:hover div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:active div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:active div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:visited div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:visited div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:focus div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:focus div {
  color: #ffffff !important;
}
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:hover *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:hover *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:active *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:active *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:visited *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:visited *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:focus *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:focus * {
  color: #ffffff !important;
}
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo * {
  color: #ffffff !important;
}
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo h1,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo span,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo div,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a {
  color: #ffffff !important;
}
.ant-pro-layout .ant-pro-layout-sider {
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo {
  background: rgba(0, 21, 41, 0.8);
}
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo img {
  height: 32px !important;
  width: 32px !important;
  border-radius: 6px;
}
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo h1,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo .ant-typography,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo span {
  color: #ffffff !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  margin: 0 !important;
}
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:hover,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:active,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:visited {
  color: #ffffff !important;
  text-decoration: none;
}
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a h1,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:hover h1,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:active h1,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:visited h1,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a .ant-typography,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:hover .ant-typography,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:active .ant-typography,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:visited .ant-typography,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a span,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:hover span,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:active span,
.ant-pro-layout .ant-pro-layout-sider .ant-pro-layout-sider-logo a:visited span {
  color: #ffffff !important;
}
.ant-pro-layout .ant-menu {
  border-right: none;
}
.ant-pro-layout .ant-menu .ant-menu-item:hover {
  background-color: rgba(24, 144, 255, 0.06);
}
.ant-pro-layout .ant-menu .ant-menu-item-selected {
  background-color: rgba(24, 144, 255, 0.1);
  border-right: 3px solid #1890ff;
}
.page-container {
  padding: 24px;
}
.page-container .page-header {
  margin-bottom: 24px;
}
.page-container .page-header .ant-page-header-heading-title {
  color: var(--text-color);
  font-weight: 600;
}
.content-wrapper {
  background: #fff;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--box-shadow);
  padding: 24px;
  margin-bottom: 24px;
}
.content-wrapper.no-padding {
  padding: 0;
}
.ant-pro-page-container .ant-pro-page-container-header {
  background: linear-gradient(135deg, #f0f2f5 0%, #ffffff 100%);
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
}
.ant-pro-page-container .ant-pro-page-container-header .ant-pro-page-container-header-title {
  color: var(--primary-color);
  font-weight: 600;
  font-size: 24px;
}
.ant-pro-page-container .ant-pro-page-container-header .ant-pro-page-container-header-sub-title {
  color: var(--text-secondary);
  font-size: 14px;
}
.ant-pro-page-container .ant-pro-page-container-header .ant-pro-page-container-header-content {
  color: var(--text-light-color);
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.5;
}
.ant-pro-page-container .ant-pro-page-container-children-content {
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  box-shadow: var(--box-shadow);
  padding: 24px;
  margin-top: 0;
}
.ant-upload-drag {
  border: 2px dashed var(--border-color) !important;
  border-radius: var(--border-radius-lg) !important;
  background: var(--background-surface) !important;
  transition: all var(--transition-duration) var(--transition-smooth) !important;
}
.ant-upload-drag:hover {
  border-color: var(--primary-color) !important;
  background: rgba(24, 144, 255, 0.02) !important;
}
.ant-upload-drag .ant-upload-drag-icon {
  color: var(--primary-color) !important;
}
.ant-btn-primary {
  background: var(--primary-gradient);
  border: none;
  border-radius: var(--border-radius);
  font-weight: 500;
  transition: all var(--transition-duration) var(--transition-smooth);
}
.ant-btn-primary:hover {
  background: var(--primary-light);
  transform: translateY(-1px);
  box-shadow: var(--box-shadow-hover);
}
.ant-pro-layout .ant-pro-layout-header [class*="logo"] *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo *,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo * {
  color: #ffffff !important;
}
.ant-pro-layout .ant-pro-layout-header [class*="logo"] a,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a,
.ant-pro-layout .ant-pro-layout-header [class*="logo"] a:hover,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:hover,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:hover,
.ant-pro-layout .ant-pro-layout-header [class*="logo"] a:focus,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:focus,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:focus,
.ant-pro-layout .ant-pro-layout-header [class*="logo"] a:active,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:active,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:active,
.ant-pro-layout .ant-pro-layout-header [class*="logo"] a:visited,
.ant-pro-layout .ant-pro-layout-header .ant-pro-layout-header-logo a:visited,
.ant-pro-layout .ant-pro-layout-header .ant-pro-global-header-logo a:visited {
  color: #ffffff !important;
}
.ant-pro-layout .ant-pro-layout-header h1[class*="logo"],
.ant-pro-layout .ant-pro-layout-header span[class*="logo"],
.ant-pro-layout .ant-pro-layout-header div[class*="logo"],
.ant-pro-layout .ant-pro-layout-header a[class*="logo"],
.ant-pro-layout .ant-pro-layout-header h1:has([class*="logo"]),
.ant-pro-layout .ant-pro-layout-header span:has([class*="logo"]),
.ant-pro-layout .ant-pro-layout-header div:has([class*="logo"]),
.ant-pro-layout .ant-pro-layout-header a:has([class*="logo"]) {
  color: #ffffff !important;
}
.ant-pro-layout-header [class*="logo"] {
  color: #ffffff !important;
}
.ant-pro-layout-header [class*="logo"] * {
  color: #ffffff !important;
}
.ant-pro-layout-header [class*="logo"] a {
  color: #ffffff !important;
}
.ant-pro-layout-header [class*="logo"] a:hover,
.ant-pro-layout-header [class*="logo"] a:focus,
.ant-pro-layout-header [class*="logo"] a:active,
.ant-pro-layout-header [class*="logo"] a:visited {
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/App.less"],"names":[],"mappings":"AACA;EAEI,aAAA;EACA,SAAA;AADJ;AAFA;EAOI,iBAAA;AAFJ;AAOA;EACE,yBAAA;AALF;AAIA;EAII,yBAAA;AALJ;AAUA;EAEI,4DAAA;EACA,yCAAA;AATJ;AAMA;;EAOM,kCAAA;AATN;AAEA;;EAUQ,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AARR;AALA;;;;;;;;EAiBQ,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;EACA,oBAAA;AAFR;AAnBA;;;;;;;;;;EAyBQ,yBAAA;EACA,gCAAA;AAMR;AAhCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6BU,yBAAA;AA6CV;AA1EA;;;;;;;;;;EAiCU,yBAAA;AAqDV;AAtFA;;EAsCQ,yBAAA;AAoDR;AA1FA;;;;EA+CM,yBAAA;AAiDN;AAhGA;EAoDI,2CAAA;AA+CJ;AAnGA;EAuDM,gCAAA;AA+CN;AAtGA;EA0DQ,uBAAA;EACA,sBAAA;EACA,kBAAA;AA+CR;AA3GA;;;EAgEQ,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,oBAAA;AAgDR;AAnHA;;;;EAuEQ,yBAAA;EACA,qBAAA;AAkDR;AA1HA;;;;;;;;;;;;EA2EU,yBAAA;AA6DV;AArDA;EACE,kBAAA;AAuDF;AAxDA;EAII,0CAAA;AAuDJ;AA3DA;EAQI,yCAAA;EACA,+BAAA;AAsDJ;AAjDA;EACE,aAAA;AAmDF;AApDA;EAII,mBAAA;AAmDJ;AAvDA;EAOM,wBAAA;EACA,gBAAA;AAmDN;AA7CA;EACE,gBAAA;EACA,sCAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;AA+CF;AA7CE;EACE,UAAA;AA+CJ;AA1CA;EAEI,6DAAA;EACA,0BAAA;EACA,gBAAA;AA2CJ;AA/CA;EAOM,2BAAA;EACA,gBAAA;EACA,eAAA;AA2CN;AApDA;EAaM,4BAAA;EACA,eAAA;AA0CN;AAxDA;EAkBM,8BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAyCN;AA9DA;EA0BI,mBAAA;EACA,0BAAA;EACA,6BAAA;EACA,aAAA;EACA,aAAA;AAuCJ;AAlCA;EACE,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,8EAAA;AAoCF;AAlCE;EACE,6CAAA;EACA,+CAAA;AAoCJ;AA5CA;EAYI,sCAAA;AAmCJ;AA9BA;EACE,mCAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,mEAAA;AAgCF;AA9BE;EACE,gCAAA;EACA,2BAAA;EACA,mCAAA;AAgCJ;AA3BA;;;EAMM,yBAAA;AA0BN;AAhCA;;;;;;;;;;;;;;;EAUM,yBAAA;AAuCN;AAjCI;;;;;;;;EAEE,yBAAA;AAyCN;AAnCA;EACE,yBAAA;AAqCF;AAtCA;EAII,yBAAA;AAqCJ;AAzCA;EAQI,yBAAA;AAoCJ;AAlCI;;;;EACE,yBAAA;AAuCN","sourcesContent":["// App组件样式 - Ant Design Pro 兼容\n.ant-pro-layout {\n  .ant-pro-layout-content {\n    padding: 24px;\n    margin: 0;\n  }\n  \n  .ant-pro-layout-content-children {\n    min-height: 280px;\n  }\n}\n\n// 确保用户名显示正确，覆盖全局样式\n.user-display-name {\n  color: #8b5cf6 !important;\n  \n  * {\n    color: #8b5cf6 !important;\n  }\n}\n\n// ProLayout 主题定制\n.ant-pro-layout {\n  .ant-pro-layout-header {\n    background: linear-gradient(90deg, #001529 0%, #002140 100%);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    \n    .ant-pro-layout-header-logo,\n    .ant-pro-global-header-logo {\n      background: transparent !important;\n      \n      img {\n        height: 32px !important;\n        width: 32px !important;\n        border-radius: 6px;\n        margin-right: 12px;\n      }\n      \n      h1, .ant-typography, span, div {\n        color: #ffffff !important;\n        font-size: 20px !important;\n        font-weight: 600 !important;\n        letter-spacing: 0.5px;\n        margin: 0 !important;\n      }\n      \n      a, a:hover, a:active, a:visited, a:focus {\n        color: #ffffff !important;\n        text-decoration: none !important;\n        \n        h1, .ant-typography, span, div {\n          color: #ffffff !important;\n        }\n        \n        * {\n          color: #ffffff !important;\n        }\n      }\n      \n      * {\n        color: #ffffff !important;\n      }\n    }\n    \n    // 覆盖所有可能的logo文字样式 - 仅限Logo区域\n    .ant-pro-layout-header-logo h1, \n    .ant-pro-layout-header-logo span, \n    .ant-pro-layout-header-logo div, \n    .ant-pro-layout-header-logo a {\n      color: #ffffff !important;\n    }\n  }\n  \n  .ant-pro-layout-sider {\n    box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);\n    \n    .ant-pro-layout-sider-logo {\n      background: rgba(0, 21, 41, 0.8);\n      \n      img {\n        height: 32px !important;\n        width: 32px !important;\n        border-radius: 6px;\n      }\n      \n      h1, .ant-typography, span {\n        color: #ffffff !important;\n        font-size: 18px !important;\n        font-weight: 600 !important;\n        margin: 0 !important;\n      }\n      \n      a, a:hover, a:active, a:visited {\n        color: #ffffff !important;\n        text-decoration: none;\n        \n        h1, .ant-typography, span {\n          color: #ffffff !important;\n        }\n      }\n    }\n  }\n}\n\n// 菜单定制\n.ant-pro-layout .ant-menu {\n  border-right: none;\n  \n  .ant-menu-item:hover {\n    background-color: rgba(24, 144, 255, 0.06);\n  }\n  \n  .ant-menu-item-selected {\n    background-color: rgba(24, 144, 255, 0.1);\n    border-right: 3px solid #1890ff;\n  }\n}\n\n// 页面容器样式\n.page-container {\n  padding: 24px;\n  \n  .page-header {\n    margin-bottom: 24px;\n    \n    .ant-page-header-heading-title {\n      color: var(--text-color);\n      font-weight: 600;\n    }\n  }\n}\n\n// 内容区域美化\n.content-wrapper {\n  background: #fff;\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--box-shadow);\n  padding: 24px;\n  margin-bottom: 24px;\n  \n  &.no-padding {\n    padding: 0;\n  }\n}\n\n// PageContainer 样式增强\n.ant-pro-page-container {\n  .ant-pro-page-container-header {\n    background: linear-gradient(135deg, #f0f2f5 0%, #ffffff 100%);\n    border-radius: 8px 8px 0 0;\n    margin-bottom: 0;\n    \n    .ant-pro-page-container-header-title {\n      color: var(--primary-color);\n      font-weight: 600;\n      font-size: 24px;\n    }\n    \n    .ant-pro-page-container-header-sub-title {\n      color: var(--text-secondary);\n      font-size: 14px;\n    }\n    \n    .ant-pro-page-container-header-content {\n      color: var(--text-light-color);\n      margin-top: 8px;\n      font-size: 14px;\n      line-height: 1.5;\n    }\n  }\n  \n  .ant-pro-page-container-children-content {\n    background: #ffffff;\n    border-radius: 0 0 8px 8px;\n    box-shadow: var(--box-shadow);\n    padding: 24px;\n    margin-top: 0;\n  }\n}\n\n// 文件上传区域样式优化\n.ant-upload-drag {\n  border: 2px dashed var(--border-color) !important;\n  border-radius: var(--border-radius-lg) !important;\n  background: var(--background-surface) !important;\n  transition: all var(--transition-duration) var(--transition-smooth) !important;\n  \n  &:hover {\n    border-color: var(--primary-color) !important;\n    background: rgba(24, 144, 255, 0.02) !important;\n  }\n  \n  .ant-upload-drag-icon {\n    color: var(--primary-color) !important;\n  }\n}\n\n// 按钮样式增强\n.ant-btn-primary {\n  background: var(--primary-gradient);\n  border: none;\n  border-radius: var(--border-radius);\n  font-weight: 500;\n  transition: all var(--transition-duration) var(--transition-smooth);\n  \n  &:hover {\n    background: var(--primary-light);\n    transform: translateY(-1px);\n    box-shadow: var(--box-shadow-hover);\n  }\n}\n\n// 强制覆盖所有可能的logo文字样式\n.ant-pro-layout .ant-pro-layout-header {\n  // 最高优先级的logo文字颜色覆盖\n  [class*=\"logo\"], \n  .ant-pro-layout-header-logo,\n  .ant-pro-global-header-logo {\n    * {\n      color: #ffffff !important;\n    }\n    \n    a, a:hover, a:focus, a:active, a:visited {\n      color: #ffffff !important;\n    }\n  }\n  \n  // 确保header内所有文字都是白色，排除用户显示名称\n  h1, span, div, a {\n    &[class*=\"logo\"], \n    &:has([class*=\"logo\"]) {\n      color: #ffffff !important;\n    }\n  }\n}\n\n// 全局强制logo区域文字为白色\n.ant-pro-layout-header [class*=\"logo\"] {\n  color: #ffffff !important;\n  \n  * {\n    color: #ffffff !important;\n  }\n  \n  a {\n    color: #ffffff !important;\n    \n    &:hover, &:focus, &:active, &:visited {\n      color: #ffffff !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
